import PropTypes from "prop-types";
import React, {useEffect} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { actions } from "../../../redux/authentication/actions";
import { isAuthenticated } from "../GenerateRoutes/generateRoutes";
import CustomSelect from "../Select/select";
import NotifierActions from "../../../redux/notifier/actions";
import InfoIcon from "@material-ui/icons/Info";
import { GET_SURVEY_ACTIVE } from "../../../services/survey/services";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tabs,
  Tab,
  Tooltip,
  Button,
  Grid,
  OutlinedInput,
  InputAdornment, Typography,
  Dialog, DialogTitle,DialogContent, DialogActions, DialogContentText
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import './styles.scss';
import AccountCircle from "@material-ui/icons/AccountCircle";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import CloseIcon from "@material-ui/icons/Close";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import {
    IMPORT_ORDINI_ATS,
    IMPORT_IDLAVORAZIONI,
    IMPORT_ORDINIFORNITORE,
    IMPORT_FAILUREREPORT,
    RESULT_IMPORT,
    RESULT_IMPORT_FR,
    RESULT_IMPORT_FILE,
    GET_FILE_STATUS,
    IMPORT_DATEPREVISIONALICONSEGNA,
    IMPORT_BONIFICHE_FAILURE_RIPARATI,
    IMPORT_EM,
    IMPORT_SURVEY, GET_ALERTS
} from "../../../services/header/services";
import ImportDialog from "../ImportDialog/importDialog";
import { POLLING_IMPORT } from "../../../services/service";
// import {ReactComponent as LogoHeader} from '../../../assets/Logo_Armonia.svg';
import { ReactComponent as LogoHeader } from '../../../assets/logoarmonia_bianco.svg';
import {
  armoniaTokenName, getRolesArray,
  getToken, getTokenField,
  sessionGetBooleanData, sessionGetData, sessionRemoveAllData, sessionRemoveData, sessionSaveBooleanData,
  sessionSaveData, tokenRolesField, tokenUsernameField
} from "../../../services/session-storage-management/session-storage-management";
import Cookies from "js-cookie";
import AlertWeb from "../AlertWeb/alertWeb";

const useStyles = theme => ({
  dialog:{
    fontFamily:'TIM Sans',
    padding:25,
    minWidth:'40%',
    minHeight:'25%'
  },
  dialogTitle:{
    color: '#ff0000',
    padding:'unset'
  },
  dialogTitleText:{
    font:'Bold 17px/23px TIM Sans'
  },
  dialogContent:{
    padding:'unset'
  },
  dialogContentText:{
    font: 'Regular 14px/19px TIM Sans',
    color:'#000',
  },
  cancelButton:{
    font: 'Bold 14px/19px TIM Sans',
    textTransform: 'none',
    color:'#000'
  },
  messageSurvey:{
    font: 'Bold 16px/19px TIM Sans',
    color:'red'
  },
  container: {
    color: "#FFFFFF",
    background: "#03B8FF",
    boxShadow: "unset",
  },
  grow: {
    flexGrow: 1
  },
  Logistica: {
    color: '#FFFFFF',
    fontSize: '20px',
    marginLeft: '1em',
    fontFamily: 'TIM Sans',
    fontWeight: 'Bold',
    position: 'absolute',
    marginTop: '-0.3em',
  },
  actionContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  separator: {
    opacity: '50%',
    width: "1px",
    height: 20,
    background: "#FFFFFF"
  },
  importContainer: {
    font: "Bold 14px/16px TIM Sans",
    textTransform: "unset",
    marginRight: 5,
    color: "#FFFFFF",
    "&:hover": {
      color: "red"
    }
  },
  importIcon: {
    color: '#FFFFFF',
    marginLeft: 5
  },
  indicator: {
    height: '10px',
    borderTop: '2px solid #018ABE',
    maxWidth: '120px',
    marginLeft: '20px',
    marginBottom: '4px',
    color: '#FFFFFF',
  },
  rootIndicator: {
    borderBottom: 'none !important',
    "& .MuiSvgIcon-root": { fill: "#FFFFFF" }
  },
  toolbar: {
    display: 'flex',
    minHeight: "55px"
  },
  tab: {
    opacity: '60 %',
    height: "55px",
    textAlign: "left",
    color: '#FFFFFF',
    font: "14px/19px TIM Sans",
    letterSpacing: 0,
    textTransform: "none"
  },
  colorIcon: {
    color: "#FFFFFF",
    "&:hover": {
      color: "#FFFFFF"
    }
  },
  importInput: {
    width: "100%",
    minHeight: "56px"
  },
  marginBottom: {
    marginBottom: "30px",
    marginTop: "45px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  noPadding: {
    paddingRight: "0"
  },
  scroller: {
    margin: '0 -10px',
    padding: '0 10px',
    listStyle: 'none',
    display: 'flex',
    overflowX: 'auto !important',
  },
  dataImport: {
    color: '#000',
    padding: '0 0 0 5px',
    font: '400 13px/18px TIM Sans',
  },
  numberDataImport: {
    font: 'Bold 13px/18px TIM Sans',
  }
});

const _AlertImportDialog = {
  buttonLabel: "Import",
  cancelLabel: "Annulla",
  successLabel: "Importa",
  title: "Importa File"
};

const _importInfoDefault = {
  PROCESSING: 0,
  PENDING: 0,
  FAILED: 0,
  DONE: 0
};


const selectImportTypology = () => {
  if (getRolesArray(tokenRolesField)[0].includes("ROLE_AZ_RIPARATRICE")) {
    return ["Failure Report"]
  }
  if (getTokenField(tokenRolesField).includes("ROLE_AZESTERNA") ||
      getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE") ||
      getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_WAREHOUSE") ||
      getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_INSTALLER") ||
      getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_INSTALLER") ||
      getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_WAREHOUSE")) {
    return ["Survey"]
  }
  else if (getRolesArray(tokenRolesField)[0].includes("ADMIN")) {

    if (getTokenField(tokenUsernameField) === 'ADMIN') {
      return ["Dati Lavorazione", "Ordini fornitore", "Carica ordini per ATS", /*"Import Em"*/, "Import Em Massive", "Import Bonifiche Failure Riparato"]

    } else {
      // return ["Dati Lavorazione", "Ordini fornitore", "Carica ordini per ATS","Import Em"]
      return ["Dati Lavorazione", "Ordini fornitore", "Carica ordini per ATS", /*"Import Em"*/]
    }
  }
  return ["Dati Lavorazione", "Ordini fornitore", "Carica ordini per ATS", /*"Import Em"*/]


};

const tabSectionMap = {
    0: "Schede Passive",
    1: "Schede Spare parts",
    2: "Ordine fornitore",
    3: "Pali e tralicci",
    4: "Giacenze e Cespiti",
    5: "Report di rientro",
    6: "Failure report",
    7: "Giacenza magazzino",
    8: "Dashboard",
    9: "Survey Verifica Giacenza",
    10: "Buoni Prelievo",
};


class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      fileName: "",
      openedDialog: false,
      openAlertDialog: false,
      file: null,
      importTask: "",
      importTaskFornitore: "Feedback RDA",
      alertData: null,
      selectedTab: 0 ,
      imported: false,
      uuidResultImport: '',
      downloadDataImport: true,
      Pending: 0,
      Processing: 0,
      Done: 0,
      Failed: 0,
      showDataImport: false,
      importInfo: {
        PENDING: 0,
        PROCESSING: 0,
        FAILED: 0,
        DONE: 0
      }
    };

    this.handleMenu = this.handleMenu.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.setAnchorEl = this.setAnchorEl.bind(this);
    this.importFile = this.importFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeAlertDialog = this.closeAlertDialog.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.handleChangeTab = this.handleChangeTab.bind(this);
    this.resetSavedFilters = this.resetSavedFilters.bind(this);

    window.addEventListener("storage",(e)=>{
      this.setState({
        ...this.state,
        surveyActive: e.target.sessionStorage.surveyActive
      })
    })
    if(isAuthenticated() && (getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE") ||
        getTokenField(tokenRolesField).includes("ROLE_ADMIN") || 
                              getTokenField(tokenRolesField).includes("ROLE_AZESTERNA") || 
                              getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_WAREHOUSE") || 
                              getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_WAREHOUSE") || 
                              getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_INSTALLER") ||
                              getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_INSTALLER")  ) ){
      GET_SURVEY_ACTIVE().then(data => {
        if(data.data.data){
          sessionSaveBooleanData(data.data.data, 'surveyActive');
          // localStorage.setItem('surveyActive', data.data.data)
        }
        window.dispatchEvent( new Event('storage') )
      });
    }
  }

    fetchAlert = () => {
        GET_ALERTS().then(res => {
            const response = res.data || {};
            if (response.data && response.data.length > 0) {
                this.setState({ alertData: response.data });
            } else {
                this.setState({ alertData: [] });
            }
        }).catch(() => {
          this.setState({ alertData: [] }); // Non mostrare alert in caso di errore
          this.props.dispatch(NotifierActions.REMOVE_NOTIFICATION());
        });
    }

  componentDidMount() {
    // console.info(getTokenField(tokenRolesField))
    // console.info(window.location.href)
    if (isAuthenticated()) {
      this.fetchAlert();
    }

    else if (window.location.href.includes("materialsheets")) {
      this.setState({
        ...this.state,
        selectedTab: 0,
        imported: false,
      })
    }


    else if (window.location.href.includes("spareparts")) {
      this.setState({
        ...this.state,
        selectedTab: 1,
        imported: false
      });
    }
    else if (window.location.href.includes("orders")) {
      this.setState({
        ...this.state,
        selectedTab: 2,
        imported: false
      });
    }

    else if (window.location.href.includes("palietralicci")) {
      this.setState({
        ...this.state,
        selectedTab: 3,
        imported: false
      });
    }
    else if (window.location.href.includes("anagraficaseriali")) {
      this.setState({
        ...this.state,
        selectedTab: 4,
        imported: false
      });
    } else if (window.location.href.includes("buoniPrelievoExport")){
      this.setState({
        ...this.state,
        selectedTab: 12,
        imported: false
      });
      
    }
    else this.setState({
      ...this.state,
      selectedTab: 5,
      imported: false
    })
  }

  componentDidUpdate() {
    if (this.state.selectedTab !== 0 && window.location.href.includes("materialsheets")) {
      this.setState({
        ...this.state,
        selectedTab: 0
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 1 && window.location.href.includes("spareparts")) {
      this.setState({
        ...this.state,
        selectedTab: 1
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 2 && window.location.href.includes("orders")) {
      this.setState({
        ...this.state,
        selectedTab: 2
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 3 && window.location.href.includes("palietralicci")) {
      this.setState({
          ...this.state,
          selectedTab: 3
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 4 && window.location.href.includes("anagraficaseriali")) {
      this.setState({
        ...this.state,
        selectedTab: 4
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 5 && window.location.href.includes("dismissionreport")) {
      this.setState({
        ...this.state,
        selectedTab: 5
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 6 && window.location.href.includes("failurereport")) {
      this.setState({
        ...this.state,
        selectedTab: 6
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 7 && window.location.href.includes("giacenzaMagazzino")) {
      this.setState({
        ...this.state,
        selectedTab: 7
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 8 && window.location.href.includes("dashboardAdmin")) {
      this.setState({
        ...this.state,
        selectedTab: 8
      }, () => {
          this.fetchAlert();
      });
    }
    // else if (this.state.selectedTab !== 9 && window.location.href.includes("surveyAdmin")) {
    //   this.setState({
    //     ...this.state,
    //     selectedTab: 9
    //   });
    // }
    else if (this.state.selectedTab !== 9 && window.location.href.includes("surveyDitta")) {
      this.setState({
        ...this.state,
        selectedTab: 9
      }, () => {
          this.fetchAlert();
      });
    }
   
    else if (this.state.selectedTab !== 10 && window.location.href.includes("surveyAdmin")) {
      this.setState({
        ...this.state,
        selectedTab: 10
      }, () => {
          this.fetchAlert();
      });
    }

    else if (this.state.selectedTab !== 11 && window.location.href.includes("buoniPrelievoList")) {
      this.setState({
        ...this.state,
        selectedTab: 11
      }, () => {
          this.fetchAlert();
      });
    }
    else if (this.state.selectedTab !== 12 && window.location.href.includes("buoniPrelievoExport")) {
      this.setState({
        ...this.state,
        selectedTab: 12
      }, () => {
          this.fetchAlert();
      });
    }
  }

  setAnchorEl = value => {
    this.setState({ anchorEl: value });
  };

  handleMenu = event => {
    this.setAnchorEl(event.currentTarget);
  };

  handleClose = () => {
    this.setAnchorEl(null);
  };

  resetSavedFilters = () => {
    if (sessionGetData("filters")) sessionRemoveData("filters");
  };

  handleChange = event => {
    this.setState({
      ...this.state,
      [event.target.name]: event.target.value
    });
  };

  closeAlertDialog = (event, reason) => {
    if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
        // Set 'open' to false, however you would do that with your particular code.
        this.setState({
          ...this.state,
          openAlertDialog: false
        })
    }
  }

  handleChangeTab = (event, value) => {
    sessionRemoveData("filters");
    this.setState({
      ...this.state,
      selectedTab: value
    });

    if(!this.state.alertData){
      this.fetchAlert();
    }

    if (value === 0) {
      this.props.history.push("/materialsheets");
    }

    else if (value === 1) {
      this.props.history.push("/spareparts");
    }
    else if (value === 2) {
      this.props.history.push("/orders");
    }
    else if (value === 3) {
      this.props.history.push("/palietralicci");
    }
    else if (value === 4) {
      this.props.history.push("/anagraficaseriali");
    }
    else if (value === 5) {
      this.props.history.push("/dismissionreport");
    }
    else if (value === 6) {
      this.props.history.push("/failurereport");
    }
    else if (value === 7) {
      this.props.history.push("/giacenzaMagazzino");
    }
    else if (value === 8) {
      this.props.history.push("/dashboardAdmin");
    }
    // else if (value === 9) {
    //   this.props.history.push("/surveyAdmin");
    // }
    else if (value === 9) {
      this.props.history.push("/surveyDitta");
    }
    else if (value === 10) {
      this.props.history.push("/surveyAdmin");
    }
    else if (value === 11) {
      this.props.history.push("/buoniPrelievoList");
    }
    else if (value === 12) {
      this.props.history.push("/buoniPrelievoExport");
    }
  };

  handleLogout = () => {

    // TODO Da togliere quando il BE sarà pronto ???
    Cookies.remove(armoniaTokenName);

    this.setAnchorEl(null);
    const isOldLogin = sessionGetBooleanData("oldLogin");
    sessionRemoveAllData();

    localStorage.removeItem("closedAlerts");

    if (!isOldLogin) {
      const url = !!window.origin ? window.origin : window.location.protocol + '//' + window.location.hostname;
      window.location.href = url + '/samlAuth/logoutArmonia?idAPP=arm';
    } else {
      this.props.dispatch({
        type: [actions.AUTHORIZATION_ERROR],
        token: null,
        username: null,
        loggedIn: false
      });

      // window.location.reload();
      this.props.history.push("/loginOld");
    }

  };



  pollingImport = uuid => {
    if (uuid) {
      setTimeout(() => {
        POLLING_IMPORT(uuid).then(
          data => {
            let response = data.data.data;
            let _newJson = {};
            this.setState({ ...this.state, Pending: 0, Processing: 0, Done: 0, Failed: 0, downloadDataImport: true })
            this.setState({ showDataImport: true })
            this.setState({ uuidResultImport: uuid })
            //eslint-disable-next-line
            response.map(ele => {
              if (ele.outcome === "DONE") {
                this.setState({ Done: ele.rows })
              }
              if (ele.outcome === "DONE" && ele.outcome !== "PROCESSING") {
                this.setState({ Processing: 0 })
              }
              if (ele.outcome === "PENDING") {
                this.setState({ Pending: ele.rows })
              }
              if (response.length <= 1 && ele.outcome === "PROCESSING") {
                this.setState({ Pending: 0 })
              }
              if (ele.outcome === "PROCESSING" && ele.outcome === "DONE") {
                this.setState({ Pending: 0 })
              }
              if (response.length <= 1 && ele.outcome === "DONE") {
                this.setState({ Pending: 0 })
                this.setState({ Processing: 0 })
              }
              if (ele.outcome === "PROCESSING") {
                this.setState({ Processing: ele.rows })
              }
              if (ele.outcome === "FAILED") {
                this.setState({ Failed: ele.rows })
              }

              // let finishImport = response.map(ele => {return (ele)})
              //   if(finishImport.outcome !== "PROCESSING" && finishImport.outcome !== "PENDING"){
              //     if(response.length <= 2 && finishImport.outcome === "DONE" || finishImport.outcome === "FAILED"){
              //       this.setState({Pending: 0})
              //     }
              //   }
            })

            if (!response.length) {
              GET_FILE_STATUS(uuid).then(data => {
                if (data.data.data.message !== 'DONE' && data.data.data.message !== 'FAILED') {
                  this.pollingImport(uuid);
                } else {
                  this.setState({
                    ...this.state,
                    fileName: "",
                    file: null,
                    importInfo: { ..._importInfoDefault },
                    imported: false,
                    downloadDataImport: false
                    // openedDialog: false
                  });
                  this.props.dispatch(
                    NotifierActions.SHOW_NOTIFICATION({
                      message: 'File non processato correttamente',
                      variant: 'error',
                      open: true
                    })
                  );
                }
              });
              return;
            }

            response.forEach(el => {
              _newJson = {
                ..._importInfoDefault
              };
              _newJson[el["outcome"]] = el.rows;
            });

            if (_newJson["PROCESSING"] === 0 && _newJson["PENDING"] === 0) {
              let _message = "";
              let _status = "";

              if (_newJson["DONE"] > 0 && _newJson["FAILED"] > 0) {
                _status = "warning";
                _message =
                  _newJson["DONE"] +
                  " Righe importate e" +
                  _newJson["FAILED"] +
                  " Righe fallite";
              } else if (_newJson["DONE"] > 0 && _newJson["FAILED"] === 0) {
                _status = "success";
                _message = _newJson["DONE"] + " Righe importate correttamente";
              } else if (_newJson["DONE"] === 0 && _newJson["FAILED"] > 0) {
                _status = "error";
                _message = _newJson["FAILED"] + " Righe fallite";
              }
              this.setState({
                ...this.state,
                fileName: "",
                file: null,
                importInfo: { ..._importInfoDefault },
                imported: false,
                downloadDataImport: false,
                // openedDialog: false
              });
              this.props.dispatch(
                NotifierActions.SHOW_NOTIFICATION({
                  message: _message,
                  variant: _status,
                  open: true
                })
              );
              return;
            } else {
              this.pollingImport(uuid);
            }
          },
          () => {
            this.props.dispatch(
              NotifierActions.SHOW_NOTIFICATION({
                message:
                  "Si è verificato un problema nella lettura del file, riprova",
                variant: "warning",
                open: true
              })
            );
            this.setState({
              ...this.state,
              fileName: "",
              file: null,
              importInfo: { ..._importInfoDefault },
              imported: false,
              downloadDataImport: false
              // openedDialog: false
            });
          }
        );
      }, 1500);
    } else {
      console.log("WARNING_UUID_NOT_FOUND");
    }
  };

  importFile = () => {
    let data = new FormData();
    data.append("file", this.state.file);
    this.setState({ ...this.state, imported: true });
    if (this.state.importTask === "Dati Lavorazione") {
      IMPORT_IDLAVORAZIONI(data).then(
        response => {
          this.pollingImport(response.data.data.uuid);
        },
        () =>
          this.setState({
            ...this.state,
            fileName: "",
            file: null,
            imported: false
          })
      );
    }
    if (this.state.importTask === "Failure Report") {
      IMPORT_FAILUREREPORT(data).then(
        response => {
          this.pollingImport(response.data.data.uuid);
        },
        () =>
          this.setState({
            ...this.state,
            fileName: "",
            file: null,
            imported: false
          })
      );
    }
    else if (this.state.importTask === "Carica ordini per ATS") {
      IMPORT_ORDINI_ATS(data).then(
        response => {
          this.pollingImport(response.data.data.uuid);
        },
        () =>
          this.setState({
            ...this.state,
            fileName: "",
            file: null,
            imported: false
          })
      );
    }
    else if (this.state.importTask === "Import Em") {
      IMPORT_EM(data).then(
        response => {
          this.pollingImport(response.data.data.uuid);
        },
        () =>
          this.setState({
            ...this.state,
            fileName: "",
            file: null,
            imported: false
          })
      );
    }
    else if (this.state.importTask === "Import Em Massive") {
      IMPORT_EM(data).then(
        response => {
          this.pollingImport(response.data.data.uuid);
        },
        () =>
          this.setState({
            ...this.state,
            fileName: "",
            file: null,
            imported: false
          })
      );
    }
    else if (this.state.importTask === "Survey") {
      IMPORT_SURVEY(data, getTokenField(tokenRolesField).includes("ROLE_AZESTERNA") ? '?entityTypeEnum=SURVEY_AZESTERNA' : '?entityTypeEnum=SURVEY').then(
        response => {
          // this.pollingImport(response.data.data.uuid);
          this.setState({
            ...this.state,
            openedDialog: false,
            imported: false,
            openAlertDialog: true
          })
        },
        () =>
          this.setState({
            ...this.state,
            fileName: "",
            file: null,
            imported: false
          })
      );
    }
    else if (this.state.importTask === "Import Bonifiche Failure Riparato") {
      IMPORT_BONIFICHE_FAILURE_RIPARATI(data).then(
        data => {

          try {

            const url = window.URL.createObjectURL(new Blob([data.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', data.headers['content-disposition'].split('filename=')[1]);
            document.body.appendChild(link);
            link.click();
            this.setState({ openDialog: false })
            this.setState({ showDataImport: false })
            this.setState({ imported: false })
          } catch (Exe) {
            this.setState({
              ...this.state,
              fileName: "",
              file: null,
              imported: false
            })
            return null
          }

        },
        () => {

          this.setState({
            ...this.state,
            fileName: "",
            file: null,
            imported: false
          })
        }
      );
    }
    else if (this.state.importTask === "Ordini fornitore") {
      if (this.state.importTaskFornitore === "Date previsionali di consegna") {
        //pml/purchaseOrder/import?feedback=DATE
        IMPORT_DATEPREVISIONALICONSEGNA(data).then(
          response => {
            this.pollingImport(response.data.data.uuid);
          },
          () =>
            this.setState({
              ...this.state,
              fileName: "",
              file: null,
              imported: false
            })
        );
      } else {
        IMPORT_ORDINIFORNITORE(
          data,
          this.state.importTaskFornitore === "Feedback RDA" ? "rda" : "po"
        ).then(
          response => {
            this.setState({ ...this.state, imported: true });
            this.pollingImport(response.data.data.uuid);
          },
          () =>
            this.setState({
              ...this.state,
              fileName: "",
              file: null,
              imported: false
            })
        );
      }
    }
  };

  uploadFile(event) {
    let file = event.target.files[0];
    if (file) {
      this.setState({ ...this.state, file: file, fileName: file.name });
    }
  }


  resultImport(file) {
    if (file === 'Failure Report') {
      RESULT_IMPORT_FR(this.state.uuidResultImport).then(
        data => {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', data.headers['content-disposition'].split('filename=')[1]);
          document.body.appendChild(link);
          link.click();
          this.setState({ openDialog: false })
          this.setState({ showDataImport: false })
          this.setState({ ...this.state, Pending: 0, Processing: 0, Done: 0, Failed: 0, })
        })
    } else if (file === 'Import Em') {
      RESULT_IMPORT_FILE(this.state.uuidResultImport, { "entityTypeEnum": "EM" }).then(
        data => {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', data.headers['content-disposition'].split('filename=')[1]);
          document.body.appendChild(link);
          link.click();
          this.setState({ openDialog: false })
          this.setState({ showDataImport: false })
          this.setState({ ...this.state, Pending: 0, Processing: 0, Done: 0, Failed: 0, })
        })
    } else if (file === 'Import Em Massive') {
      RESULT_IMPORT_FILE(this.state.uuidResultImport, { "entityTypeEnum": "EM_MASSIVE" }).then(
        data => {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', data.headers['content-disposition'].split('filename=')[1]);
          document.body.appendChild(link);
          link.click();
          this.setState({ openDialog: false })
          this.setState({ showDataImport: false })
          this.setState({ ...this.state, Pending: 0, Processing: 0, Done: 0, Failed: 0, })
        })
    } else {
      RESULT_IMPORT(this.state.uuidResultImport).then(
        data => {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', data.headers['content-disposition'].split('filename=')[1]);
          document.body.appendChild(link);
          link.click();
          this.setState({ openDialog: false })
          this.setState({ showDataImport: false })
          this.setState({ ...this.state, Pending: 0, Processing: 0, Done: 0, Failed: 0, })
        })
    }
  }
  render() {
    const classes = this.props.classes;
    const _isAuth = isAuthenticated() && isAuthenticated().length;
    const {alertData, selectedTab} = this.state;
    const closedAlerts = JSON.parse(localStorage.getItem("closedAlerts") || "[]");
    let surveyActive;
    if(this.state.surveyActive){
      if(this.state.surveyActive.toLowerCase() == 'false' || this.state.surveyActive == false ){
        surveyActive = false;
      } else {
        surveyActive = true
      }
    }
    
    return _isAuth
      && getRolesArray(tokenRolesField)[0].includes("ROLE")
      ? (
          <div>
            <AppBar position="static" className={classes.container}>
              <Toolbar className={classes.toolbar}>

                <LogoHeader/>
                <Tabs
                    variant="scrollable"
                    scrollButtons="auto"
                    value={this.state.selectedTab}
                    onChange={this.handleChangeTab}
                    indicatorColor="white"
                    aria-label="tab"
                    name="value"
                    classes={{indicator: classes.indicator, root: classes.rootIndicator,}}
                >
                  {
                    getTokenField(tokenRolesField).includes("ROLE_USER_PNRR") ||
                    getTokenField(tokenRolesField).includes("ROLE_AZ_RIPARATRICE") ||
                    getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE") ||
                    getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_WAREHOUSE") ||
                    getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_INSTALLER") ||
                    getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_INSTALLER") ||
                    getTokenField(tokenRolesField).includes("ROLE_AZESTERNA") ||
                    getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_WAREHOUSE") ||
                    getTokenField(tokenRolesField).includes("ROLE_VISITOR") ? null :
                        <Tab
                            value={0}
                            index={0}
                            onClick={this.resetSavedFilters}
                            className={classes.tab}
                            style={{width: "78px"}}
                            label="Schede Passive"
                        />
                  }
                  {getTokenField(tokenRolesField).includes("ROLE_ADMIN") ||
                  getTokenField(tokenRolesField).includes("ROLE_VISITOR")
                  || getTokenField(tokenRolesField).includes("ROLE_PROGETTISTA_INT_SPARE") ?
                      <Tab
                          value={1}
                          index={1}
                          onClick={this.resetSavedFilters}
                          className={classes.tab}
                          label="Schede Spare parts"
                      /> : null
                  }
                  {getTokenField(tokenRolesField).includes("ROLE_ADMIN") ?
                      <Tab
                          value={2}
                          index={2}
                          onClick={this.resetSavedFilters}
                          className={classes.tab}
                          label="Ordine fornitore"
                      /> : null}

                  {/* {getTokenField(tokenRolesField)[0] !== "ROLE_ADMIN" ? null : (
              <Tab
                value={3}
                index={3}
                onClick={this.resetSavedFilters}
                className={classes.tab}
                label="Pali e tralicci"
              />
            )} */}
                  {getTokenField(tokenRolesField).includes("ROLE_ADMIN")
                      ?
                      (
                          <Tab
                              value={4}
                              index={4}
                              onClick={this.resetSavedFilters}
                              className={classes.tab}
                              label="Giacenze e Cespiti"
                          />
                      )
                      :
                      getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE") ||
                      getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_WAREHOUSE") ||
                      getTokenField(tokenRolesField).includes("ROLE_AZESTERNA") ||
                      getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_WAREHOUSE") ||
                      getTokenField(tokenRolesField).includes("ROLE_VISITOR") ||
                      getTokenField(tokenRolesField).includes("ROLE_PROGETTISTA_INT") ||
                      getTokenField(tokenRolesField).includes("ROLE_PROGETTISTA_INT_SPARE")
                          ?
                          (
                              <Tab
                                  value={4}
                                  index={4}
                                  onClick={this.resetSavedFilters}
                                  className={classes.tab}
                                  label="Giacenze"
                              />
                          )
                          :
                          null}
                  {
                    getTokenField(tokenRolesField).includes("ROLE_ADMIN") ||
                    getTokenField(tokenRolesField).includes("ROLE_MAGAZZINO") ||
                    getTokenField(tokenRolesField).includes("ROLE_AZESTERNA") || getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_WAREHOUSE")

                        ?
                        <Tab
                            value={5}
                            index={5}
                            onClick={this.resetSavedFilters}
                            className={classes.tab}
                            label="Report di rientro"
                        /> : null
                  }
                  {
                    getTokenField(tokenRolesField).includes("ROLE_ADMIN") ||
                    getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_WAREHOUSE") ||
                    getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE") ||
                    getTokenField(tokenRolesField).includes("ROLE_MAGAZZINO") || getTokenField(tokenRolesField).includes("ROLE_AZ_RIPARATRICE") ?
                        <Tab
                            value={6}
                            index={6}
                            onClick={this.resetSavedFilters}
                            className={classes.tab}
                            label="Failure report"
                        /> : null
                  }
                  {getTokenField(tokenRolesField).includes("ROLE_ADMIN") ||
                  getTokenField(tokenRolesField).includes("ROLE_MAGAZZINO") ? (
                      <Tab
                          value={7}
                          index={7}
                          onClick={this.resetSavedFilters}
                          className={classes.tab}
                          label="Giacenza magazzino"
                      />
                  ) : null}
                  {getTokenField(tokenRolesField).includes("ROLE_ADMIN") || getTokenField(tokenRolesField).includes("ROLE_VISITOR") || getTokenField(tokenRolesField).includes("ROLE_MAGAZZINO") ? (
                          <Tab
                              value={8}
                              index={8}
                              onClick={this.resetSavedFilters}
                              className={classes.tab}
                              label="Dashboard"
                          />)
                      : null}
                  {/* {getTokenField(tokenRolesField).includes("ROLE_ADMIN") ? (
                <Tab
                value={9}
                index={9}
                onClick={this.resetSavedFilters}
                className={classes.tab}
                label="Survey admin"
                />)
              : null} */}
                  {
                    (getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE") ||
                        getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_WAREHOUSE") ||
                        getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_INSTALLER") ||
                        getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_INSTALLER") ||
                        getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_WAREHOUSE") ||
                        getTokenField(tokenRolesField).includes("ROLE_AZESTERNA")) && surveyActive ? (
                            <Tab
                                value={9}
                                index={9}
                                onClick={this.resetSavedFilters}
                                className={classes.tab}
                                label="Survey Verifica Giacenza"
                            />)
                        : null}
                  {getTokenField(tokenRolesField).includes("ROLE_ADMIN") && surveyActive ? (
                          <Tab
                              value={10}
                              index={10}
                              onClick={this.resetSavedFilters}
                              className={classes.tab}
                              label="Survey Verifica Giacenza"
                          />)
                      : null}
                  {
                    getTokenField(tokenRolesField).includes("ROLE_ADMIN") ?
                        <Tab
                            value={11}
                            index={11}
                            onClick={this.resetSavedFilters}
                            className={classes.tab}
                            style={{width: "78px"}}
                            label="Buoni Prelievo"
                        /> : null
                  }
                  {
                    getTokenField(tokenRolesField).includes("ROLE_USER_PNRR") ?
                        <Tab
                            value={12}
                            index={12}
                            onClick={this.resetSavedFilters}
                            className={classes.tab}
                            style={{width: "78px"}}
                            label="Buoni Prelievo Export"
                        /> : null
                  }
                </Tabs>
                <div className={classes.grow}/>
                <div className={classes.actionContainer}>
                  {getTokenField(tokenRolesField).includes("ROLE_ADMIN") ||
                  getTokenField(tokenRolesField).includes("ROLE_AZ_RIPARATRICE") ||
                  getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE") ||
                  getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_WAREHOUSE") ||
                  getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE_INSTALLER") ||
                  getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_INSTALLER") ||
                  getTokenField(tokenRolesField).includes("ROLE_AZESTERNA_WAREHOUSE") ||
                  getTokenField(tokenRolesField).includes("ROLE_AZESTERNA") ? (
                      <>

                        <ImportDialog
                            isOpened={this.state.openedDialog}
                            closeDialog={() =>
                                this.setState({
                                  ...this.state,
                                  fileName: "",
                                  file: null,
                                  openedDialog: false,
                                  showDataImport: false,
                                  importTask: null
                                })
                            }
                            openDialog={() =>
                                this.setState({
                                  ...this.state,
                                  fileName: "",
                                  file: null,
                                  openedDialog: true
                                })
                            }
                            blackButton={false}
                            iconComponent={
                              <ImportExportIcon className={classes.importIcon}/>
                            }
                            isMenuButton={false}
                            successFunction={this.importFile}
                            handleCloseFunction={() =>
                                this.setState({
                                  ...this.state,
                                  file: null,
                                  fileName: "",
                                  openedDialog: false,
                                  imported: false
                                })
                            }
                            disableSend={!this.state.fileName}
                            isImported={this.state.imported}
                            {..._AlertImportDialog}
                        >
                          {getTokenField(tokenRolesField).includes("ROLE_AZESTERNA") || getTokenField(tokenRolesField).includes("ROLE_MANUTENTORE") ?
                              (<div><Typography variant="h7" className={classes.messageSurvey}>Attenzione! Per l'import
                                Survey inserire solo le colonne in verde scaricate dall'export</Typography></div>)
                              : null}
                          <Grid container alignItems="center">
                            <Grid item className={classes.marginBottom} sm={12}>
                              <CustomSelect
                                  labelWidth={100}
                                  // options={getTokenField(tokenRolesField)[0].includes("AZ_RIPARATRICE")?["Failure Report"]:["Dati Lavorazione", "Ordini fornitore", "Carica ordini per ATS","Import Em"]}
                                  options={selectImportTypology()}
                                  // "Valori giacenza volano"]}
                                  label="Tipologia Import"
                                  name="importTask"
                                  value={this.state.importTask}
                                  onChange={this.handleChange}
                              />
                              <Tooltip
                                  title="Seleziona la tipologia di file da importare. I file supportati sono in formato xlsx.">
                                <InfoIcon
                                    style={{
                                      color: "#BABABA",
                                      marginLeft: 15,
                                      marginTop: 10
                                    }}
                                />
                              </Tooltip>
                            </Grid>
                            {this.state.importTask === "Ordini fornitore" ? (
                                <Grid
                                    item
                                    style={{
                                      margin: "0 0 25px 0",
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center"
                                    }}
                                    sm={10}
                                >
                                  <CustomSelect
                                      labelWidth={55}
                                      options={["Feedback RDA", "Feedback PO", "Date previsionali di consegna"]}
                                      label="Feedback"
                                      name="importTaskFornitore"
                                      value={this.state.importTaskFornitore}
                                      onChange={this.handleChange}
                                  />
                                  <Tooltip title="Seleziona la categoria del feedback">
                                    <InfoIcon
                                        style={{
                                          color: "#BABABA",
                                          marginLeft: 15,
                                          marginTop: 10
                                        }}
                                    />
                                  </Tooltip>
                                </Grid>
                            ) : null}
                            <Grid item sm={12}>
                              <OutlinedInput
                                  className={classes.importInput}
                                  classes={{root: classes.noPadding}}
                                  type="text"
                                  disabled={true}
                                  value={this.state.fileName}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <input
                                          style={{display: "none"}}
                                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                          id="contained-button-file"
                                          type="file"
                                          onChange={this.uploadFile}
                                      />
                                      <label htmlFor="contained-button-file">
                                        <Button
                                            variant="contained"
                                            style={{
                                              width: "104px",
                                              height: "54px",
                                              marginRight: "1px",
                                              boxShadow: "none",
                                              borderRadius: "0px 4px 4px 0px",
                                              textTransform: "capitalize",
                                              font: "Bold 14px/19px TIM Sans",
                                              color: "#FFF",
                                              background:
                                                  "#9CA1A9 0% 0% no-repeat padding-box",
                                              opacity: "0.59"
                                            }}
                                            component="span"
                                        >
                                          Importa
                                        </Button>
                                      </label>
                                    </InputAdornment>
                                  }
                              />
                            </Grid>
                            {this.state.showDataImport && (
                                <Grid item sm={10} style={{marginTop: '2.5em', display: 'flex'}}>
                                  <Grid item xs={6}>
                                    <Typography className={classes.dataImport}>Da elaborare: <span
                                        className={classes.numberDataImport}>{this.state.Pending}</span></Typography>
                                    <Typography className={classes.dataImport}>In elaborazione: <span
                                        className={classes.numberDataImport}>{this.state.Processing}</span></Typography>
                                    <Typography className={classes.dataImport}>Completati: <span
                                        className={classes.numberDataImport}>{this.state.Done}</span></Typography>
                                    <Typography className={classes.dataImport}>Falliti: <span
                                        className={classes.numberDataImport}>{this.state.Failed}</span></Typography>
                                  </Grid>
                                  <Grid item xs={6} style={{marginTop: '0.9em'}}>
                                    {getRolesArray(tokenRolesField)[0].includes("AZ_RIPARATRICE__") ? null :
                                        <Button className="newOrderContent__new"
                                                disabled={this.state.downloadDataImport}
                                                onClick={() => this.resultImport(this.state.importTask)}
                                                style={this.state.downloadDataImport ? {
                                                  color: "#fff",
                                                  opacity: "50%"
                                                } : null}>Scarica risultati import</Button>}
                                  </Grid>
                                </Grid>
                            )}

                          </Grid>
                        </ImportDialog>

                        <Dialog open={this.state.openAlertDialog} classes={{paper: classes.dialog}}
                                onClose={(event, reason) => this.closeAlertDialog(event, reason)}>
                          <DialogTitle className={classes.dialogTitle}>
                            <Grid container alignItems="center" direction="row">
                              <Grid item className={classes.dialogTitleText}>Attenzione!</Grid>
                              <Grid item className={classes.grow}></Grid>
                              <Grid item>
                                <IconButton aria-label="close" className={classes.closeIcon}
                                            onClick={(event, reason) => this.closeAlertDialog(event, reason)}>
                                  <CloseIcon/>
                                </IconButton>
                              </Grid>
                            </Grid>
                          </DialogTitle>
                          <DialogContent classes={{root: classes.dialogContent}}>
                            <DialogContentText component="div" className={classes.dialogContentText}>
                              Potrebbero volerci diversi minuti per completare l'import.<br></br>
                              Andare nella sezione <b>Risultati Import</b> e verificare che il caricamento sia terminato
                              correttamente.
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={(event, reason) => this.closeAlertDialog(event, reason)}
                                    className={classes.cancelButton}>
                              Ho capito!
                            </Button>
                          </DialogActions>
                        </Dialog>


                        <div className={classes.separator}/>
                        {" "}
                      </>
                  ) : null}

                  <IconButton
                      disabled={true}
                      edge="end"
                      className={classes.colorIcon}
                      style={{marginLeft: 12}}
                      aria-label="Account"
                      aria-haspopup="true"

                  >
                    <AccountCircle style={{color: '#FFFFFF'}}/>
                  </IconButton>

                  <IconButton onClick={this.openConsoleMonitoring}>
                <span style={{
                  marginLeft: '0.3em',
                  fontFamily: 'TIM Sans',
                  fontSize: '14px',
                  color: '#FFFFFF',
                  textTransform: 'capitalize'
                }}>
                  {sessionGetData('Username')}
                </span>
                  </IconButton>

                  <div className={classes.separator} style={{marginLeft: '1.5em'}}/>

                  <Tooltip title="Esci" aria-label="add">
                    <IconButton
                        className={classes.colorIcon}
                        style={{marginLeft: 12}}
                        aria-label="Disconnetti"
                        edge="end"
                        color="inherit"
                        onClick={this.handleLogout}
                    >
                      <ExitToAppIcon/>
                    </IconButton>
                  </Tooltip>

                </div>
              </Toolbar>
            </AppBar>
              {/*
              <div className="header-info-alert">

                  VI RICORDIAMO CHE A GENNAIO 2026 IL MAGAZZINO ATS SARA’ CHIUSO PER INVENTARIO.

                  PER ESSERE GESTITE, LE SCHEDE DOVRANNO ESSERE INVIATE ENTRO E NON OLTRE IL <span className="header-info-alert-span">05/01/2026</span>.<br/>

                  DALL’<span className="header-info-alert-span">08/01/2026</span> LE SCHEDE VERRANNO GESTITE CON PRESA IN CARICO E SPEDIZIONE A PARTIRE DAL <span className="header-info-alert-span">25/01/2026</span>.
              </div>
              */}

            {Array.isArray(alertData) && alertData.length > 0 && alertData
                .filter(alert => !closedAlerts.includes(alert.id))
                .map((alert, idx) => (
                    <AlertWeb
                        key={alert.id || idx}
                        id={alert.id}
                        testo={alert.testo}
                        coloreBg={alert.coloreBg}
                        coloreTesto={alert.coloreTesto}
                        alertSection={alert.sezione}
                        activeSection={tabSectionMap[selectedTab]}
                        isClosable={alert.isClosable}
                    />
                ))
            }

          </div>
  ) : null

  }


}

Header.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withRouter,
  withStyles(useStyles),
  connect(state => ({
    ...state
  }))
)(Header);
